(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AnimateScrollTo"] = factory();
	else
		root["AnimateScrollTo"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _helpers = __webpack_require__(1);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_helpers).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Scroll = __webpack_require__(2);

var _Scroll2 = _interopRequireDefault(_Scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animateScrollTo = function animateScrollTo(to, duration) {
  var scroll = new _Scroll2.default(to, duration);

  scroll.animateScroll();
};

exports.default = animateScrollTo;
module.exports = exports['default'];

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Scroll = function () {
  /**
   * Scroll to a particular location
   *
   * @param to       int Pixels to scroll to
   * @param duration int How long scroll must take in ms
   */
  function Scroll(to, duration) {
    _classCallCheck(this, Scroll);

    this.elapsed = 0;
    this.start = window.pageYOffset;
    this.change = to - this.start;
    this.duration = duration;
    this.increment = 20;
  }

  /**
   * Animate scrolling
   */


  Scroll.prototype.animateScroll = function animateScroll() {
    var _this = this;

    this.elapsed += this.increment;

    // Get new position
    var position = this.easeInOut();

    // Scroll to new position
    window.scrollTo(0, position);

    // Rerun function if position is not yet correct
    if (this.elapsed < this.duration) {
      setTimeout(function () {
        return _this.animateScroll();
      }, this.increment);
    }
  };

  /**
   * easeInOut animation for scrolling
   */


  Scroll.prototype.easeInOut = function easeInOut() {
    var elapsed = this.elapsed;
    var start = this.start,
        change = this.change,
        duration = this.duration;


    elapsed /= duration / 2;

    if (elapsed < 1) {
      return change / 2 * elapsed * elapsed + start;
    }

    elapsed -= 1;

    return -change / 2 * (elapsed * (elapsed - 2) - 1) + start;
  };

  return Scroll;
}();

exports.default = Scroll;
module.exports = exports["default"];

/***/ })
/******/ ]);
});